export enum VisualizationType {
  SummaryCard = 0,
  BarGraph = 1,
  PivotTable = 2
}

export const VisualizationTypeDisplay = {
  [VisualizationType.SummaryCard]: '(Card)',
  [VisualizationType.BarGraph]: '(Bar Graph)',
  [VisualizationType.PivotTable]: '(Data Table)'
}

export const VisualizationTypeTitle = {
  [VisualizationType.SummaryCard]: 'Summary Card',
  [VisualizationType.BarGraph]: 'Bar Graph',
  [VisualizationType.PivotTable]: 'Data Table'
}

export enum DataPointAggregationType {
  Sum = 0,
  Average = 1,
  Minimum = 2,
  Maximum = 3,
  Count = 4
}

export const DataPointAggregationString = {
  [DataPointAggregationType.Sum]: 'Total',
  [DataPointAggregationType.Average]: 'Avg',
  [DataPointAggregationType.Minimum]: 'Min',
  [DataPointAggregationType.Maximum]: 'Max',
  [DataPointAggregationType.Count]: 'Count',
}

export enum DataPointValueFormatType {
  Number = 0,
  Percentage = 1
}

export enum BarLayoutOptions {
  Vertical = 0,
  Horizontal = 1
}

export enum DataPointType {
  Dimension = 0,
  Measure = 1,
  Fusion = 2,
}